// TopParent imagery, self-hosted as WebP for performance.
//
// Only the photos actually rendered on a page live here. The previous
// version exported 27+ Unsplash references, all unused except the two
// neurodiverse-play comparison photos.

const brandAsset = (path) =>
    `https://customer-assets.emergentagent.com/job_parent-first-play/artifacts/${path}`;

// Branded campaign imagery used in editorial / story sections.
export const brandPhotos = {
    // "Animal Path Game" - hand drawing on a wooden block with markers
    animalPathGame: brandAsset("gzylm05e_Animal%20Path%20game.jpg"),
    // "Copy-Me Sound Game" - parent and child with letter blocks
    copyMeSoundGame: brandAsset("q9t2qcbp_Copy%20me%20sound%20game.jpg"),
    // Sandra + Joseph at Parent Focus Group (self-hosted WebP, was 22 MB PNG).
    sandraJoseph: "/brand-images/sandra-charis.webp",
    // Neurodiverse hero: parent crafting with child nearby.
    homeCraftMoment: brandAsset(
        "tap40hzm_kevin-malik-Z_aoaPGRYL0-unsplash.jpg",
    ),
    // "What You Have At Home Is Enough" flat-lay (self-hosted WebP, was 1.9 MB PNG).
    enoughFlatlayWarm: "/brand-images/enough-flatlay-warm.webp",
};

// Neurodiverse Tuesday/Wednesday comparison panel. Self-hosted WebP.
export const photos = {
    crayonsTable: "/brand-images/crayons-table.webp",
    woodenToyPile: "/brand-images/wooden-toy-pile.webp",
};
